import { $api } from "../generated/client";

export const useGetCustomerCarrierPortalLink = (shopId: string) => {
  return $api.useQuery("get", "/shops/{shopId}/billings/carrier-setup-link", {
    params: { path: { shopId } },
  });
};
